export default function formataNumeracaoAmostra(amostraSelecionada) {
  const [l, n] = amostraSelecionada.split(' ');
  return l + Number(n)
}
